/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import { FC } from 'react'
import { Routes, Route, BrowserRouter, Navigate } from 'react-router-dom'
// import { PrivateRoutes } from './PrivateRoutes'
import { ChiefOfficeRoutes } from './ChiefOfficeRoutes'
import { ManagerRoutes } from './ManagerRoutes'
import { RepresentativeRoutes } from './RepresentativeRoutes'
import { SupperAdminRoutes } from './SupperAdminRoutes'
import { TrainingRoutes } from './TrainingRoutes'
import { ShareholderRoutes } from './ShareholderRoutes'
import { ErrorsPage } from '../modules/errors/ErrorsPage'
import { Logout, AuthPage, useAuth } from '../modules/auth'
import { App } from '../App'
import { CONSTANT } from '../../constant'

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const { PUBLIC_URL } = process.env

const AppRoutes: FC = () => {
  const { currentUser } = useAuth()
  let routes = (
    <>
      <Route path='auth/*' element={<AuthPage />} />
      <Route path='*' element={<Navigate to='/auth' />} />
    </>
  );

  if (currentUser) {
    switch (currentUser.role?.slug) {
      case CONSTANT.ROLE.SUPER_ADMIN:
        routes = (
          <>
            <Route path='/*' element={<SupperAdminRoutes />} />
            <Route index element={<Navigate to='/report-sale/report-manager' />} /> 
            <Route path='/shareholder/*' element={<ShareholderRoutes />} />
          </>
        )
        break;
      case CONSTANT.ROLE.CHIEF_OFFICE:
        routes = (
          <>
            <Route path='/*' element={<ChiefOfficeRoutes />} />
            <Route index element={<Navigate to='/sales' />} />
          </>
        )
        break;

      case CONSTANT.ROLE.MANAGER:
        routes = (
          <>
            <Route path='/*' element={<ManagerRoutes />} />
            <Route index element={<Navigate to='/sales' />} />
          </>
        )
        break;
      case CONSTANT.ROLE.REPRESENTATIVE_OFFICE:
        routes = (
          <>
            <Route path='/*' element={<RepresentativeRoutes />} />
            <Route index element={<Navigate to='/sales' />} />
          </>
        )
        break;
      case CONSTANT.ROLE.TRAINING:
        routes = (
          <>
            <Route path='/*' element={<TrainingRoutes />} />
            <Route index element={<Navigate to='/sales' />} />
          </>
        )
        break;
      case CONSTANT.ROLE.SHAREHOLDER:
      case CONSTANT.ROLE.CUSTOMER_CARE:
        routes = (
          <>
            <Route path='/*' element={<ShareholderRoutes />} />
            <Route index element={<Navigate to='/sharehoder-management' />} />
          </>
        )
        break;
      // case CONSTANT.ROLE.LEADER:
      //   routes = (
      //     <>
      //       <Route path='/*' element={<PrivateRoutes />} />
      //       <Route index element={<Navigate to='/dashboard' />} />
      //     </>
      //   )
      //   break;
    }
  }

  return (
    <BrowserRouter basename={PUBLIC_URL}>
      <Routes>
        <Route element={<App />}>
          <Route path='error/*' element={<ErrorsPage />} />
          <Route path='logout' element={<Logout />} />
          {routes}
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export { AppRoutes }
